const getAnswerSheet = (sectionData, userAnswers) => {
  let questionNumber = 1;
  const clonedAnswers = structuredClone(userAnswers);
  if (userAnswers !== null && Object.values(userAnswers).length > 0) {
    questionNumber = Object.values(userAnswers).length + 1;
  }
  
  // Handle both data structures: sectionData.tabs or sectionData as array
  const tabs = sectionData.tabs || sectionData;
  // Get sectionId - might be at root level or undefined for array structure
  const sectionId = sectionData.sectionId || null;
  
  tabs.forEach((tab) => {
    tab.tabContent.forEach((tabContent) => {
      switch (tabContent.type) {
        case "multipleChoice":
          if (tabContent.questionId) {
            clonedAnswers[tabContent.questionId] = {
              sectionId: sectionId,
              answer: null,
              answerId: null,
              questionNumber: questionNumber++,
              questionId: tabContent.questionId,
            };
          }
          break;
        case "input":
          tabContent.questionList.forEach((question) => {
            if (question.questionId) {
              clonedAnswers[question.questionId] = {
                sectionId: sectionId,
                answerId: null,
                answer: "",
                questionNumber: questionNumber++,
                questionId: question.questionId,
              };
            }
          });
          break;
        case "speaking":
          if (tabContent.questionId) {
            clonedAnswers[tabContent.questionId] = {
              sectionId: sectionId,
              mp3File: null,
              audioTranscript: "",
              questionNumber: questionNumber++,
              questionId: tabContent.questionId,
            };
          }
          break;
        case "writing":
          if (tabContent.questionId) {
            clonedAnswers[tabContent.questionId] = {
              sectionId: sectionId,
              answerId: null,
              answer: "",
              questionNumber: questionNumber++,
              questionId: tabContent.questionId,
            };
          }
          break;
        default:
          break;
      }
    });
  });
  
  console.log("Returning clonedAnswers:", clonedAnswers);
  return clonedAnswers;
};

export default getAnswerSheet;